(function () {
  function init(root) {
    if (!root || root.getAttribute('data-bn-reviews-ready')) return;
    root.setAttribute('data-bn-reviews-ready', '1');

    var shopName = root.getAttribute('data-bn-shop-name') || '';
    var API = 'https://app.aitrillion.com/review/process_v1.php';
    var S3 = 'https://static.aitrillion.com/';
    var SITE = 'https://app.aitrillion.com/review/';

    window.addEventListener('message', function (event) {
      var data = event.data;
      if (!data || data.type !== 'bn-reviews-height') return;
      var frames = root.querySelectorAll('.bn-item-reviews__frame');
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].contentWindow === event.source) {
          var h = Math.max(160, parseInt(data.height, 10) || 0);
          if (h) frames[i].style.height = h + 'px';
          break;
        }
      }
    });

    function applyPlaceholders(html, productId) {
      var map = {
        '{aio_default_css}': '',
        '{frontCustomerReviews}': 'CUSTOMER REVIEWS',
        '{frontWriteAReviewBtn}': 'Write a review',
        '{frontAskAQuestionBtn}': 'Ask a question',
        '{aio_review_site_url}': SITE,
        '{aio_shop_name}': shopName,
        '{s3_path}': S3,
        '{aio_product_id}': String(productId),
        '{aio_textColor}': '000000',
        '{aio_reviewStarColor}': 'ffbe0c',
        '{aio_reviewColor}': 'DED89B',
        '{aioName}': 'Name',
        '{aioEmail}': 'Email',
        '{aioName_placeholder}': 'john.smith',
        '{aioEmail_placeholder}': 'john.smith@example.com',
        '{aioTxt_submit_review_button}': 'Submit Review',
        '{aioScore}': 'Rating',
        '{aioTitle}': 'Title',
        '{aioTitlePlaceholder}': 'Give your review a title',
        '{aioReviews}': 'Review',
        '{aioCommentplaceholder}': 'Write your comments here',
        '{aioUploadImageLabel}': 'Add photos',
        '{aioChoose_file_btn_heading}': 'Choose File',
        '{aioQuestion_description}': 'Question',
        '{aioquestion_description_placeholder}': 'Write your question here',
        '{aioTxt_submit_question_btn}': 'Submit Question'
      };
      var out = html || '';
      Object.keys(map).forEach(function (key) {
        out = out.split(key).join(map[key]);
      });
      return out.split('starttag').join('script');
    }

    function buildDoc(parts, productId, productUrl) {
      var body =
        applyPlaceholders(parts.content || '', productId) +
        (parts.bif || '') +
        (parts.listing || '') +
        (parts.ratingHtml || '');

      return (
        '<!DOCTYPE html><html><head><meta charset="utf-8">' +
        '<meta name="viewport" content="width=device-width,initial-scale=1">' +
        '<link href="https://fonts.googleapis.com/css2?family=Assistant&display=swap" rel="stylesheet">' +
        '<link href="https://static.aitrillion.com/aio-script/aio-review-v2-min.css" rel="stylesheet">' +
        '<style>' +
        'html,body{margin:0;padding:0;background:#fff;font-family:Assistant,sans-serif;}' +
        '#egg_review_container{display:block!important;position:relative;}' +
        '.page-width{max-width:100%;padding:0;}' +
        '.bn-write-link{display:inline-block;margin:12px 0 8px;padding:8px 14px;border:1px solid #c4a574;color:#c4a574;text-decoration:none;font-size:13px;}' +
        '</style></head><body>' +
        body +
        (productUrl
          ? '<div style="padding:4px 0 16px"><a class="bn-write-link" target="_parent" href="' +
            productUrl +
            '#egg_review_container">Write a review on product page</a></div>'
          : '') +
        '<script>(function(){function p(){try{parent.postMessage({type:"bn-reviews-height",height:Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)},"*")}catch(e){}}window.addEventListener("load",p);if(window.ResizeObserver){new ResizeObserver(p).observe(document.body)}setInterval(p,700);p()})();<\/script>' +
        '</body></html>'
      );
    }

    function loadFrame(frame) {
      var productId = frame.getAttribute('data-bn-product-id');
      var productUrl = frame.getAttribute('data-bn-product-url') || '';
      if (!productId || !shopName) return Promise.resolve();

      var detailsUrl =
        API +
        '?product_id=' +
        encodeURIComponent(productId) +
        '&shop=' +
        encodeURIComponent(shopName) +
        '&act=product_details_review_html&enable_question=0&group=active';

      var ratingUrl =
        API +
        '?shop=' +
        encodeURIComponent(shopName) +
        '&key=productrating&product_data=' +
        encodeURIComponent(productId) +
        '&group=active';

      var listingUrl =
        API +
        '?listing_review_pro_id=' +
        encodeURIComponent(productId) +
        '&shop=' +
        encodeURIComponent(shopName) +
        '&page=1&act=product_review_listing&group=active';

      return Promise.all([
        fetch(detailsUrl, { mode: 'cors' }).then(function (r) {
          return r.json();
        }),
        fetch(ratingUrl, { mode: 'cors' }).then(function (r) {
          return r.json();
        }),
        fetch(listingUrl, { mode: 'cors' }).then(function (r) {
          return r.json();
        })
      ])
        .then(function (results) {
          var details = results[0] || {};
          var rating = results[1] || {};
          var listing = results[2] || {};

          if (!details.content) throw new Error('no review shell');

          var ratingHtml = '';
          if (rating && rating.data && rating.data[0] && rating.data[0].temp) {
            var row = rating.data[0];
            ratingHtml =
              '<div class="bn-rating-summary" style="padding:8px 0 16px;display:flex;align-items:center;gap:10px;flex-wrap:wrap">' +
              row.temp +
              '<span style="font-size:14px;color:#121212">' +
              (Math.round(Number(row.avg_rating) * 10) / 10).toFixed(1) +
              ' out of 5 | ' +
              row.rating_count +
              ' Reviews</span></div>';
          }

          frame.srcdoc = buildDoc(
            {
              content: details.content,
              bif: details.review_bifergation_and_images_html || '',
              listing: listing.review_html || details.review_listing_html || '',
              ratingHtml: ratingHtml
            },
            productId,
            productUrl
          );
          frame.style.height = '420px';
        })
        .catch(function () {
          frame.srcdoc =
            '<!DOCTYPE html><html><body style="margin:0;padding:12px 0;font-family:Assistant,sans-serif;color:#666">' +
            'Reviews unavailable right now. ' +
            (productUrl
              ? '<a target="_parent" href="' + productUrl + '#egg_review_container">Open product reviews</a>'
              : '') +
            '</body></html>';
          frame.style.height = '80px';
        });
    }

    var frames = root.querySelectorAll('.bn-item-reviews__frame');
    var i = 0;
    function next() {
      if (i >= frames.length) return;
      loadFrame(frames[i++]).then(next);
    }
    next();
  }

  function boot() {
    document.querySelectorAll('[data-bn-item-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-bn-item-reviews]');
    if (root) init(root);
  });
})();
